import { withRouter } from 'react-router-dom';
import {
    useState, useEffect, useCallback, useContext
} from 'react';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { useDataRefresh, ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import { useModal } from '@jutro/components';
import { renderContentFromMetadataInternal } from '@jutro/uiconfig';
import messages from './NewServiceWizardPage_AX.messages';
import styles from './NewServiceWizardPage_AX.module.scss';
import metadata from './NewServiceWizardPage_AX.metadata.json5';
import NewServiceWizardStepsComponentAX from '../../components/NewServiceWizardStepsComponent_AX/NewServiceWizardStepsComponent_AX';
import NewServiceClaimSearchAndSelectComponentAX from '../../components/NewServiceClaimSearchAndSelectComponent_AX/NewServiceClaimSearchAndSelectComponent_AX';
import NewServiceCreateComponentAX from '../../components/NewServiceCreateComponent_AX/NewServiceCreateComponent_AX';

function NewServiceWizardPageAX() {
    const translator = useTranslator();
    const { refreshData } = useDataRefresh();
    const viewModelService = useContext(ViewModelServiceContext);
    const { showAlert } = useModal();

    const [currentStep, updateCurrentStep] = useState(1);
    const [visitedSteps, updateVisitedSteps] = useState([1]);

    const [claimSearchDTO, setClaimSearchDTO] = useState({ claimNumber: '' });
    const [serviceRequestVM, setServiceRequestVM] = useState({});
    const [addressVM, setAddressVM] = useState({});
    const [serviceRequestKind, setServiceRequestKind] = useState([]);

    const [claimSelected, updateClaimSelected] = useState(undefined);
    const [exposuresClaim, setExposuresClaim] = useState([]);
    const [servicesExposure, setServicesExposure] = useState([]);

    useEffect(() => {
        if (!_.isUndefined(viewModelService)) {
            setServiceRequestVM(viewModelService.create(
                {},
                'cc',
                'edge.capabilities.servicerequest.create.dto.NewServiceRequestDTO'
            ));

            setAddressVM(viewModelService.create({
                country: _.filter(
                    viewModelService.productMetadata.get('cc').types.getTypelist('Country').codes,
                    (item) => item.code === 'MX'
                )[0].code
            }, 'cc', 'edge.capabilities.address.dto.AddressDTO'));

            setServiceRequestKind(viewModelService.productMetadata.get('cc')
                .types.getTypelist('ServiceRequestKind').codes);
        }
    }, [viewModelService]);

    const onRefreshSearchCriteria = useCallback((newModel) => {
        setClaimSearchDTO(newModel);
        refreshData();
    }, [refreshData]);

    const onRefreshServiceRequestVM = useCallback((newModel) => {
        setServiceRequestVM(newModel);
        refreshData();
    }, [refreshData]);

    const onRefreshAddressVM = useCallback((newModel) => {
        setAddressVM(newModel);
        refreshData();
    }, [refreshData]);

    const onUpdateExposuresClaim = useCallback((exposures) => {
        setExposuresClaim(exposures);
        refreshData();
    }, [refreshData]);

    const onUpdateServicesExposure = useCallback((services) => {
        setServicesExposure(services);
        refreshData();
    }, [refreshData]);

    const refreshWizardStep = useCallback((newStep) => {
        if (!visitedSteps.includes(newStep)) {
            visitedSteps.push(newStep);
            updateVisitedSteps(visitedSteps);
        }
        updateCurrentStep(newStep);
        refreshData();
    }, [refreshData, visitedSteps]);

    const onEnterStep1 = useCallback(() => {
        refreshWizardStep(1);
        return true;
    }, [refreshWizardStep]);

    const onEnterStep2 = useCallback(() => {
        if (_.isUndefined(claimSelected)) {
            showAlert({
                status: 'error',
                icon: 'error',
                title: translator(messages.missingClaimSelectedErrorTitleMsg),
                message: translator(messages.missingClaimSelectedErrorBodyMsg)
            });
            return false;
        }
        refreshWizardStep(2);
        return true;
    }, [refreshWizardStep, claimSelected, translator]);

    const onClaimSelected = useCallback((claimSearchSelected) => {
        updateClaimSelected(claimSearchSelected);
        setServiceRequestVM(viewModelService.create(
            {},
            'cc',
            'edge.capabilities.servicerequest.create.dto.NewServiceRequestDTO'
        ));
    }, [viewModelService]);

    const override = {
        stepOneComponent: {
            visible: currentStep === 1,
            setClaimSelected: onClaimSelected,
            claimSearchDTO: claimSearchDTO,
            onUpdateModel: onRefreshSearchCriteria,
            claimSelected: claimSelected,
            currentStep: currentStep
        },
        stepTwoComponent: {
            visible: currentStep === 2,
            claimSelected: claimSelected,
            serviceRequestVM: serviceRequestVM,
            onUpdateModelSRVM: onRefreshServiceRequestVM,
            serviceRequestKind: serviceRequestKind,
            addressVM: addressVM,
            exposuresClaim: exposuresClaim,
            servicesExposure: servicesExposure,
            updateExposuresClaim: onUpdateExposuresClaim,
            updateServicesExposure: onUpdateServicesExposure,
            onUpdateModelAddressVM: onRefreshAddressVM
        },
        wizardSteps: {
            onEnterStep1: onEnterStep1,
            onEnterStep2: onEnterStep2
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
        },
        resolveComponentMap: {
            newServiceWizarStep1Component: NewServiceClaimSearchAndSelectComponentAX,
            newServiceWizarStep2Component: NewServiceCreateComponentAX,
            stepsComponent: NewServiceWizardStepsComponentAX
        }
    };

    return renderContentFromMetadataInternal(metadata.pageContent, override, resolvers);
}

export default withRouter(NewServiceWizardPageAX);
